import React from "react";

class Location extends React.Component {
  render() {
    var backgrounds = {
      golden: {
        backgroundImage: 'url(https://cdn.johnbernazzani.com/golden.jpg)'
      }
    };
    return (
      <section className="location" style={backgrounds.golden} id="location">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="location-header">
                <i className="fa fa-map-marker" />Golden CO
              </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <p>
                Photo by{" "}
                <a
                  href="https://instagram.com/kevinconroy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Kevin
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Location;



// WEBPACK FOOTER //
// ./src/components/location.js